import React from 'react';

/**
 * A2UIRenderer／子元件在渲染階段 throw 時由 boundary 接住；並可透過 onError 通知父層改走其他渲染路徑。
 */
export default class A2uiRenderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.props.onError?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}
